// Archivo: InfoAdiconal.js

document.addEventListener('DOMContentLoaded', () => {
    // Acordeón principal
    const infoAdicionalMain = document.querySelector('.info-adicional-main');
    if (infoAdicionalMain) {
        infoAdicionalMain.addEventListener('click', () => {
            infoAdicionalMain.classList.toggle('active');
            document.querySelector('.info-adicional-main-content').classList.toggle('active');
        });
    }

    // Subacordeones
    const infoAdicionalSubaccordions = document.querySelectorAll('.info-adicional-main-subaccordion');
    infoAdicionalSubaccordions.forEach(subaccordion => {
        const header = subaccordion.querySelector('.info-adicional-main-subaccordion-header');
        if (header) {
            header.addEventListener('click', (event) => {
                event.stopPropagation(); // Evita que el clic en subacordeón active el acordeón principal
                // Toggle active class for content
                const content = subaccordion.querySelector('.info-adicional-main-subaccordion-content');
                if (content) {
                    content.classList.toggle('active');
                }
                // Toggle active class for header to rotate arrow
                header.classList.toggle('active');
            });
        }
    });

    // --- Integración del Efecto de Ráfaga ---

    // Función para iniciar el efecto de ráfaga
    function iniciarBrilloInfoAdicional() {
        if (!infoAdicionalMain) return;
        // Crear el elemento del efecto de ráfaga
        const brillo = document.createElement('div');
        brillo.classList.add('shine-effect-infoAdicional');

        // Añadir el brillo al contenedor de "Información Adicional"
        infoAdicionalMain.appendChild(brillo);

        // Remover el brillo después de la duración de la animación (5s)
        brillo.addEventListener('animationend', () => {
            brillo.remove();
        });
    }

    // Iniciar el brillo cada 10 segundos
    if (infoAdicionalMain) {
        setInterval(iniciarBrilloInfoAdicional, 10000);
        // Opcional: Iniciar el brillo inmediatamente al cargar la página
        iniciarBrilloInfoAdicional();
    }
});
